module.exports = __webpack_public_path__ + "static/img/bar.ace8e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bar.jpg
// module id = ZORg
// module chunks = 1